




































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { sortBy, pick } from "lodash";
import ActiveStandmansQuantity from '@/components/lfs/NewStatistics/GeneralDashboard/ActiveStandmansQuantity.vue'
import CollectTotalSchedule from '@/components/lfs/NewStatistics/GeneralDashboard/CollectTotalSchedule.vue'
import ContactsCategory from '@/components/lfs/NewStatistics/GeneralDashboard/ContactsCategory.vue'
import ContactsCollectedSchedule from '@/components/lfs/NewStatistics/GeneralDashboard/ContactsCollectedSchedule.vue'
import ContactsInterest from '@/components/lfs/NewStatistics/GeneralDashboard/ContactsInterest.vue'
import FilledSurveyList from '@/components/lfs/NewStatistics/GeneralDashboard/FilledSurveyList.vue'
import StandmansRatingList from '@/components/lfs/NewStatistics/GeneralDashboard/StandmansRatingList.vue'
import StandsProductsScanned from '@/components/lfs/NewStatistics/GeneralDashboard/StandsProductsScanned.vue'

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'GeneralDashboard',
  components: {
    ActiveStandmansQuantity,
    ContactsCategory,
    CollectTotalSchedule,
    ContactsCollectedSchedule,
    ContactsInterest,
    FilledSurveyList,
    StandmansRatingList,
    StandsProductsScanned
  }
})

export default class GeneralDashboard extends Vue {
  @statistic_v4.Getter('total') protected total: any
  @statistic_v4.Getter('surveysFilled') protected surveysFilled: any
  @statistic_v4.Getter('activeStandmans') protected activeStandmans: any
  @statistic_v4.Getter('contactAttributes') protected contactAttributes: any
  @statistic_v4.Getter('createdContacts') protected createdContacts: any
  @statistic_v4.Getter('standmansRating') protected standmansRating: any
  @statistic_v4.Getter('productScans') protected productScans: any
  @statistic_v4.Getter('loading') protected loading!: any
  @statistic_v4.Getter('error') protected error!: any
  @statistic_v4.Action('loadAll') protected loadAll!: any

    get categories(): any {
     return {
       isNew: { title: this.$t('newstatistics.general.contacts_category.isNew'), color: '#29B450', count: null },
       none: { title: this.$t('newstatistics.general.contacts_category.none'), color: '#D2CCDD', count: null },
       exists: { title: this.$t('newstatistics.general.contacts_category.exists'), color: '#2D9CDB', count: null },
     }
    }

  get totalCount() {
    return pick(this.total,
      ['sumContacts','allScans', 'scansToday', 'timestampShowStart','scansBadges','scansBusinessCard','sumCustomContact'])
  }
  get totalChart() {
    if (!this.total.timestampsWithScanCount) return []
    return this.total.timestampsWithScanCount
  }
  get totalSurveys() {
    if (!Object.keys(this.surveysFilled).length) return {}
    return pick(this.surveysFilled, ['countFilledSurveys', 'shardsWithFilledSurveys', 'filedSurveysToday'])
  }
  get normalizedsurveysFilled() {
    if (!Object.keys(this.surveysFilled).length) return []
    const sorted =  sortBy(this.surveysFilled.filledSurveys, ['count']).reverse()
    sorted.splice(5,this.surveysFilled.filledSurveys.length)
    return sorted
  }
  get totalActiveStandmans() {
    if (!Object.keys(this.activeStandmans).length) return null
    return pick(this.activeStandmans, ['activeStandmans','allStandmans'])
  }
  get avatars() {
    if (!Object.keys(this.activeStandmans).length) return []
    return this.activeStandmans['standmans'].slice(0, 5)
  }
  get contactsCategory() {
    const cat = this.contactAttributes['category']
    for (let item in cat) {
      this.categories[item].count = cat[item]
    }
    return this.categories
  }
  get contactsInterest() {
    return this.contactAttributes.hotLevel
  }
  get collectedBadges() {
    if (!this.createdContacts.allContactsCount) return []
    return this.createdContacts.allContactsCount
  }
  get collectedBusinessCards() {
    if (!this.createdContacts.filledSurveysCount) return []
    return this.createdContacts.filledSurveysCount
  }
  get collectedCustomContacts() {
    if (!this.createdContacts.customContacts) return []
    return this.createdContacts.customContacts
  }
  get collectedTimestampShowStart() {
    return this.createdContacts.timestampShowStart
  }
  get ratingByCount() {
    return this.standmansRating.byCount
  }
  get ratingByFilling() {
    return this.standmansRating.byFilling
  }

  protected mounted() {
    this.loadAll()
  }
}
